<template>
  <span>{{ name }}<small
    v-if="provider && name !== provider"
    class="ml-1 text-[0.75em] font-normal opacity-60"
  >({{ provider }})</small></span>
</template>

<script setup>
// 遊戲商顯示名稱 + 小字 (provider 代號)；名稱即代號時不重複顯示
import { computed } from 'vue'
import { useAuthStore } from '~/player/stores/auth'
import { providerDisplayName } from '~/shared/utils/providerBranding'

const props = defineProps({
  provider: { type: String, default: '' },
})

const auth = useAuthStore()
const name = computed(() => providerDisplayName(props.provider, auth.locale))
</script>
